import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics"
import { usePlatform } from "../usePlatform"

export function useHaptics() {
    function checkAvailability() {
        const { isCapacitor } = usePlatform()
        return isCapacitor()
    }

    async function feelNotification(type: string): Promise<void> {
        if (!checkAvailability() || !type)
            return

        switch (type) {
            case "success":
                await Haptics.notification({ type: NotificationType.Success })
                break
            case "warning":
                await Haptics.notification({ type: NotificationType.Warning })
                break
            case "danger":
                await Haptics.notification({ type: NotificationType.Error })
                break
            default:
                break
        }
    }

    async function feelImpact(type: string): Promise<void> {
        if (!checkAvailability() || !type)
            return

        switch (type) {
            case "light":
                await Haptics.impact({ style: ImpactStyle.Light })
                break
            case "medium":
                await Haptics.impact({ style: ImpactStyle.Medium })
                break
            case "heavy":
                await Haptics.impact({ style: ImpactStyle.Heavy })
                break
            default:
                break
        }
    }

    async function feelVibrate(duration?: number): Promise<void> {
        if (!checkAvailability())
            return

        await Haptics.vibrate({ duration: (duration) ? duration : 100 })
    }

    async function feelSelectionStart(): Promise<void> {
        if (!checkAvailability())
            return

        await Haptics.selectionStart()
    }

    async function feelSelectionChanged(): Promise<void> {
        if (!checkAvailability())
            return

        await Haptics.selectionChanged()
    }

    async function feelSelectionEnd(): Promise<void> {
        if (!checkAvailability())
            return

        await Haptics.selectionEnd()
    }

    return {
        feelNotification,
        feelImpact,
        feelVibrate,
        feelSelectionStart,
        feelSelectionChanged,
        feelSelectionEnd
    }
}
